import { Navigate } from 'react-router';

import { OutletContextTypeGuard } from '@/app/routers/guards';
import {
  isChannelRequestOutletContext,
  isNewAccountChannelRequestOutletContext,
} from '@/true-fsd/data/advertiser-account';

import {
  ChannelRequestPage,
  NewAccountChannelRequestPage,
} from '@/true-fsd/layout/ChannelRequest';

export const channelRequest = {
  path: 'channel-request',
  children: [
    {
      path: ':telegram_channel_id',
      element: (
        <OutletContextTypeGuard typeGuard={isChannelRequestOutletContext} />
      ),
      children: [
        {
          index: true,
          element: <ChannelRequestPage />,
        },
      ],
    },
    {
      index: true,
      element: <Navigate to=".." />,
    },
    {
      path: '*',
      element: <Navigate to=".." />,
    },
  ],
};

export const newAccountChannelRequest = {
  path: 'channel-request',
  children: [
    {
      path: ':telegram_channel_id',
      element: (
        <OutletContextTypeGuard
          typeGuard={isNewAccountChannelRequestOutletContext}
        />
      ),
      children: [
        {
          index: true,
          element: <NewAccountChannelRequestPage />,
        },
      ],
    },
    {
      index: true,
      element: <Navigate to=".." />,
    },
    {
      path: '*',
      element: <Navigate to=".." />,
    },
  ],
};
